import { useQuery } from '@tanstack/react-query'
import * as requests from './requests'

export const KEY_GET_GOOGLE_REVIEWS = 'getGoogleReviews'

export const useGetGoogleReviews = () =>
  useQuery({
    queryKey: [KEY_GET_GOOGLE_REVIEWS],
    queryFn: () => requests.getGoogleReviews(),
    staleTime: 60 * 60 * 1000, // 1 hora
    cacheTime: 60 * 60 * 1000, // 1 hora
    retry: 2,
    meta: {
      errorMessage: 'Erro ao buscar avaliações do Google.'
    }
  })

